






































import {
  Vue,
  Component,
  Watch,
} from 'vue-property-decorator';
import {
  Getter,
  Action,
} from 'vuex-class';
import questionGroups from '@/data/test-data';
import PersonalityTestResultView from '@/components/PersonalityTestResultView.vue';
import {
  TestWordGroup,
  TestWord,
  PersonalityTestResponse,
  AddSelectionPayload,
} from '../../types';

/**
 * This component is taking care of the profile test
 * It shows a progress bar to notify what is the current progress of the test profile
 * (how many remaining questions)
 * It also display the result once the test is done by passing the
 * answers as a prop in PersonalityTestResultView
 */
@Component({
  components: {
    PersonalityTestResultView,
  },
})
export default class PersonalityTest extends Vue {
  @Getter('selection')
  private selection!: PersonalityTestResponse;

  @Action('setGroupNumber')
  private setGroupNumber!: (number: number) => void;

  @Action('addSelection')
  private addSelection!: (payload: AddSelectionPayload) => void;

  @Action('reset')
  private reset!: () => void;

  @Getter('groupNumber')
  private currentGroupNumber!: number;

  private currentGroup: TestWordGroup|null = null;

  private progressValue = 0;

  private readonly groups: TestWordGroup[] = questionGroups;

  private created() {
    if (this.currentGroupNumber === -1) {
      // Start new test
      this.setGroupNumber(0);
      return;
    }

    // Resume progress
    this.setProgress();
  }

  private onReviewTest() {
    this.setGroupNumber(0);
  }

  private getProgressLabel() {
    if (this.currentGroupNumber >= this.groups.length) {
      return 'Finished';
    }

    return `${this.currentGroupNumber + 1} / ${this.groups.length}`;
  }

  private setProgress() {
    this.currentGroup = this.groups[this.currentGroupNumber];
    this.progressValue = parseFloat(
      (((this.currentGroupNumber + 1) / this.groups.length) * 100).toFixed(2),
    );
  }

  private onSelectWord(item: TestWord) {
    this.addSelection({ groupdId: this.currentGroupNumber, value: item.id });

    // Go to next word group
    this.setGroupNumber(this.currentGroupNumber + 1);
  }

  isWordSelected(item: TestWord) {
    return Array.from(this.selection.values()).indexOf(item.id) > -1;
  }

  @Watch('currentGroupNumber', { immediate: false, deep: true })
  onGroupChanged() {
    this.setProgress();
  }
}
